import React from 'react';

/**
 * Small downward chevron — 12px, used next to the user avatar to signal the
 * dropdown affordance.
 */
const IconChevronDown = props => (
  <svg
    className={props.className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="m3 4.5 3 3 3-3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconChevronDown;
